

import { PanelsActionTypes } from 'actionsConstants';
import { dispatch, state } from '__common/store';
import { roofHasObstructions } from '__editor/panelsEditor/components/obstructions/obstructions';

const actions = [
  PanelsActionTypes.REMOVE_PANELS,
  PanelsActionTypes.ADD_PANELS,
];

export const addPanelsMiddleware = store => next => action => {
  // console.log('action', action)
  if (!action || typeof action !== 'object' || action.type === undefined) {
    console.error('INVALID ACTION DETECTED in addPanelsMiddleware:', action);
    console.error('Action type is:', typeof action?.type);
    console.error('Full action object:', JSON.stringify(action, null, 2));
    // Don't pass invalid actions to next middleware
    return;
  }
  
  // Intercept RECHECK_PANELS_OBSTRUCTION_ZONE and inject missing state data to prevent state() calls during reducer execution
  if (action.type === PanelsActionTypes.RECHECK_PANELS_OBSTRUCTION_ZONE) {
    if (!action.payload) {
      action.payload = {};
    }
    const currentState = state();
    // Inject missing parameters that are required by checkObstructionZoneForPanels
    // to ensure the reducer never needs to call state() directly
    if (action.payload.selectedRoofId === undefined) {
      action.payload.selectedRoofId = currentState.background.selectedRoofId;
    }
    if (action.payload.metersPerPixel === undefined) {
      action.payload.metersPerPixel = currentState.background.metersPerPixel;
    }
    if (action.payload.bgX === undefined) {
      action.payload.bgX = currentState.background.bgXY.x;
    }
    if (action.payload.bgY === undefined) {
      action.payload.bgY = currentState.background.bgXY.y;
    }
    if (action.payload.productId === undefined) {
      action.payload.productId = currentState.projectConfiguration.productId;
    }
    if (action.payload.obstructions === undefined) {
      action.payload.obstructions = currentState.obstructions.obstructions;
    }
    if (!action.payload.projectConfiguration) {
      action.payload.projectConfiguration = currentState.projectConfiguration;
    }
    if (!action.payload.stateConfig) {
      action.payload.stateConfig = currentState;
    }
  }
  
  next(action);

  const currentState = state();
  const { background: { selectedRoofId, metersPerPixel, bgXY: { x, y } }, projectConfiguration, obstructions: { obstructions } } = currentState;
  const { productId } = projectConfiguration;

  if (actions.includes(action.type) && roofHasObstructions(selectedRoofId)) {
    const recheckAction = {
      type: PanelsActionTypes.RECHECK_PANELS_OBSTRUCTION_ZONE,
      payload: {
        selectedRoofId,
        metersPerPixel,
        bgX: x,
        bgY: y,
        productId,
        obstructions,
        projectConfiguration,
        stateConfig: currentState,
      },
    };
    // Defer to next event loop tick to avoid React render-phase updates
    setTimeout(() => {
      store.dispatch(recheckAction);
    }, 0);
  }
};

